import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { setInvoice } from 'redux/modules/billing';
import { BillingHistoryTable, Spinner, PageHeader } from 'components';
var OrgBillingHistory = (_dec = connect(function (state) {
  return {
    config: state.config,
    billingHistory: state.billing.billingHistory,
    organization: state.organization.current
  };
}, {
  setInvoice: setInvoice
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(OrgBillingHistory, _Component);

  var _super = _createSuper(OrgBillingHistory);

  function OrgBillingHistory() {
    var _this;

    _classCallCheck(this, OrgBillingHistory);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleInvoiceView", function (invoice) {
      _this.props.setInvoice(invoice);

      browserHistory.push("/org/".concat(_this.props.organization.id, "/settings/billing-history/invoice/").concat(invoice.stripeId));
    });

    return _this;
  }

  _createClass(OrgBillingHistory, [{
    key: "render",
    value:
    /** *********************************************************
     RENDER
     ***********************************************************/
    function render() {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          padding: 36
        }
      }, /*#__PURE__*/React.createElement(Helmet, {
        title: "Billing History"
      }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement(PageHeader, {
        primary: "Billing History"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement(BillingHistoryTable, {
        orgId: this.props.organization.id,
        handleView: this.handleInvoiceView
      }), this.props.children))));
    }
  }]);

  return OrgBillingHistory;
}(Component)) || _class);
export { OrgBillingHistory as default };